import React from 'react';
import TopTwo from './TopTwo';
import NavTwo from './NavTwo';

const HeaderFour = () => {
    return(
        <>
        <header className="o-header">
            <TopTwo />
            
            <NavTwo />
        </header>
        </>
    )
}

export default HeaderFour;